import { render, staticRenderFns } from "./ProjectSettings.vue?vue&type=template&id=601df552&scoped=true&"
import script from "./ProjectSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSettings.vue?vue&type=style&index=0&id=601df552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601df552",
  null
  
)

export default component.exports